import React, { Component } from 'react'
import NavigationItems from './Components/NavigationItems'
import PageHeader from './Components/PageHeader'
import Footer from './Components/Footer'

import Base from './Config'
import axios from 'axios'
import { WaveLoading,
  } from 'react-loadingg';

import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';

class Items extends Component {
    edit=()=>{
        // console.log('Edit ',this.props.quotation);
        this.props.Edit(this.props.quotation)
    }

    delete=()=>{
        // console.log('delete ',this.props.quotation);
        this.props.Delete(this.props.quotation)
    }

    

    render() {
        // console.log('props :',this.props);
        const item = this.props.quotation
        // console.log('item ',item);
        
        return (
            <tr>
                <th scope="row">
                <label className="font-weight-bold">{item.name}</label>
                    <br/>
                    <label className="font-weight-bold opacity-8">{item.ar_name}</label><br/>
                    <label className="opacity-6">Active : &nbsp; </label>{item.is_active?<i className="fa fa-check-circle" style={{ fontSize: 20, color: 'green' }} />:<i className="fa fa-times-circle" style={{ fontSize: 20, color: 'red' }} />}
                </th>
                <td>{item.category.name}</td>
                <td>{item.for_tenant?<i className="fa fa-check-circle" style={{ fontSize: 20, color: 'green' }} />:<i className="fa fa-times-circle" style={{ fontSize: 20, color: 'red' }} />}</td>
                <td>{item.for_outsider?<i className="fa fa-check-circle" style={{ fontSize: 20, color: 'green' }} />:<i className="fa fa-times-circle" style={{ fontSize: 20, color: 'red' }} />}</td>
                {/* <td><span style={{ fontSize: 20, color: 'red' }}>✖</span></td> */}
                <td>
                <button className="btn-sm btn-outline-primary" onClick={this.edit}>
                <i className="fas fa-edit " ></i>
                </button>
                <span>&nbsp;</span>
                <button className="btn-sm btn-outline-danger" onClick={this.delete}>
                <i className="fas fa-trash"></i>
                </button>
                </td>
            </tr>
        )
    }
}


export default class Services extends Component {
    constructor(){
        super()
        this.state={
            data:[],
            allData:[],
            next:'',
            prev:'',
            loading:true,

            name:'',
            arname:'',
            fortenant:false,
            foroutsider:false,
            selectedOption:'',
            options: [],
            is_active:false,
            edit:false,
            id:'',

            filter:false,
            tenant:false,
            outsider:false,
            search_text:"",
            sort_name:true,

        }
      this.handleChange = this.handleChange.bind(this);
    }

    edit=(data)=>{
        NotificationManager.info("Please make changes in edit section","Info",3000)

        this.setState({
            edit:true,
            id:data.id,
            name:data.name,
            arname:data.ar_name,
            fortenant:data.for_tenant,
            foroutsider:data.for_outsider,
            selectedOption:data.category.id,
            is_active:data.is_active,
        })
        // console.log('Edit parent data ',data);
    }
    deleteDay = (data)=>{
        // console.log('Delete parent data ',data);
        
        axios.delete(
            Base.url + 'Service/?service_id='+data.id,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response);
                if(response.data.Status){
                    NotificationManager.success( response.data.Message,'Success : ',3000)
                    this.fetchService()
                    this.loading(false)
                }else{
                    console.log(response.data.Message);
                    NotificationManager.error('Error : ', response.data.Error, 3000)
                    this.loading(false)
                }
        })
        .catch(error=>{
            console.log(error);
            NotificationManager.success('Error message', error,2000);

        })
    }

    EditDay=()=>{
        // console.log('edit worked');
        
        // console.log("Data");
        // console.log("name : ",this.state.name);
        // console.log("arname : ",this.state.arname);
        // console.log("option : ",this.state.selectedOption);
        // console.log("tenand : ",this.state.fortenant);
        // console.log("outsider : ",this.state.foroutsider);

        if(!this.state.name){
           NotificationManager.warning('Required : ', ' Service name', 3000);
           return false
        }
        else if(!this.state.arname){
           NotificationManager.warning('Required : ', 'Arabic Service name', 3000);
           return false
        }
        else if(!this.state.selectedOption){
           NotificationManager.warning('Required : ', 'choose a valid category', 3000);
           return false
        }
        else if(this.state.fortenant =='' && this.state.foroutsider ==''){
           NotificationManager.warning('Required : ', 'Must check at least one user type', 3000);
           return false
        }
        this.loading(true)


        let fortenant
        let foroutsider
        let is_active

        if(this.state.fortenant == true){
           fortenant = 1
        }
        else{
           fortenant = 0
        }

        if(this.state.foroutsider == true){
           foroutsider = 1
        }
        else{
           foroutsider = 0
        }

        if(this.state.is_active == true){
            is_active = 1
        }
        else{
            is_active = 0
        }
        
        // console.log("tenand : ",fortenant);
        // console.log("outsider : ",foroutsider);
        
       var bodyFormData = new FormData();
       bodyFormData.set('service_id', this.state.id);
       bodyFormData.set('name', this.state.name);
       bodyFormData.set('category_id', this.state.selectedOption);
       bodyFormData.set('arabic_name', this.state.arname);
       bodyFormData.set('for_tenants', fortenant);
       bodyFormData.set('for_outsider', foroutsider);
       bodyFormData.set('is_active', is_active);

       axios.put(
           Base.url + 'Service/',
           bodyFormData,
           {
               headers: {
                   'Authorization': 'Token ' + localStorage.getItem('Token'),
               }
           }
       )
       .then(response =>{
        //    console.log('response : ',response.data);
        //    console.log('response : ',response.data.Status);
           if(response.data.Status){
                NotificationManager.success( response.data.Message,'Success : ',3000)
               this.clearEdit()
               this.fetchService()
           }else{
               console.log(response.data.Message);
               NotificationManager.error('Error : ', response.data.Error, 3000)

           }
       })
       .catch(error=>{
           console.log(error);
           NotificationManager.error('Error : ', error, 3000)

       })

      
    }

    clearEdit=()=>{
        this.setState({
            edit:false,
            id:'',
            name:'',
            arname:'',
            fortenant:false,
            foroutsider:false,
            is_active:false,
            selectedOption:'',
        })
    }





    loading = (arg)=>{
        this.setState({
            loading:arg
        })
    }

    componentDidMount(){
        this.fetchService()
        this.fetchCategory()
    }

    fetchCategory(){
        axios.get(
            Base.url+'Category/',
            { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
            }
            ).then(response =>{
                let list=[]
                // console.log('Response Data :',response.data);
                // console.log('Response Category :',response.data.results);
                response.data.results.map((item)=>{
                    console.log();
                    list.push(
                        {id:item.id,name:item.name}
                    )
                })
                // console.log(list.sort());
                
                this.setState({
                    options:list.sort(),
                })
                
                axios.get(
                    Base.url +'Category/?limit='+response.data.count+'&offset=0',
                    {
                        headers: {
                            'Authorization': 'Token ' + localStorage.getItem('Token'),
                        }
                    }
                ).then(responseNew =>{
                    // console.log("new resp ",responseNew);
                    this.setState({
                        allData: responseNew.data.results,
                        
                    })
                }).catch(error =>{
                    console.log('Error loading quotation count: ', error);
                    NotificationManager.error('Error : ', error, 3000)

                })
            })
            .catch(error =>{
              console.log('Error loading category : ',error);
              NotificationManager.error('Error : ', error, 3000)

            }
        )
    }

    fetchService=()=>{
        let sort_name
        let user_type

        if(this.state.sort_name===true){
            sort_name = "a"
        }
        else{
            sort_name="d"
        }

        // tenant:false,
        //     outsider:false,
        if(this.state.tenant){
            user_type="T"            
        }else if(this.state.outsider){
            user_type="O"
        }else{
            user_type=""
        }

        // console.log('sort_name ',sort_name );
        // console.log('user_type ',user_type );
        

        // return false
        this.loading(true)

        axios.get(
            Base.url+'Service/?user_type='+user_type+'&search_text='+this.state.search_text+'&sort_name='+sort_name,
            { 
              headers: { 
                'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
            }
            ).then(response =>{
                // console.log('Response C :',responseCount.data);
                // console.log('Response Normal :',response.data);
                this.setState({
                    data:response.data.results,
                    next:response.data.next,
                    prev:response.data.previous,
                    loading:false,
                })
            })
            .catch(error =>{
              console.log('Error loading quotation count: ',error);
              NotificationManager.error('Error : ', error, 3000)

            }
        )
    }

    

    next=()=>{
        this.loading(true)
        axios.get(this.state.next.replace(/^http:\/\//i, 'https://'),{ headers: { 'Authorization': 'Token '+localStorage.getItem('Token'),} }
        ).then(response =>{
            // console.log('res ',response)
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{NotificationManager.error('Error : ', error, 3000)})
      }
    
      
      prev=()=>{
        this.loading(true)
        axios.get(
          this.state.prev.replace(/^http:\/\//i, 'https://'),
          { 
              headers: { 
                  'Authorization': 'Token '+localStorage.getItem('Token'),
              } 
          }
        ).then(response =>{
          this.setState({
            data:response.data.results,
            next:response.data.next,
            prev:response.data.previous,
            loading:false,
          })
        })
        .catch(error =>{
            NotificationManager.error('Error : ', error, 3000)
        })
      }
      
      handleChange(event) {
        this.setState({
            selectedOption: event.target.value
        })
      }
     
      
        
      addService=()=>{
        
         if(!this.state.name){
            NotificationManager.warning('Required Service name')
         }
         else if(!this.state.arname){
            NotificationManager.warning('Required Arabic Service name')
         }
         else if(!this.state.selectedOption){
            NotificationManager.warning('Please choose a valid category')
         }
         else if(this.state.fortenant =='' && this.state.foroutsider ==''){
            NotificationManager.warning('Must check at least one user type')
         }

         let fortenant
         let foroutsider
         if(this.state.fortenant == true){
            fortenant = 1
         }
         else{
            fortenant = 0
         }
         if(this.state.foroutsider == true){
            foroutsider = 1
         }
         else{
            foroutsider = 0
         }
         
        //  console.log("tenand : ",fortenant);
        //  console.log("outsider : ",foroutsider);
         
        var bodyFormData = new FormData();
        bodyFormData.set('name', this.state.name);
        bodyFormData.set('category_id', this.state.selectedOption);
        bodyFormData.set('arabic_name', this.state.arname);
        bodyFormData.set('for_tenants', fortenant);
        bodyFormData.set('for_outsider', foroutsider);

        axios.post(
            Base.url + 'Service/',
            bodyFormData,
            {
                headers: {
                    'Authorization': 'Token ' + localStorage.getItem('Token'),
                }
            }
        )
        .then(response =>{
            // console.log('response : ',response.data);
            // console.log('response : ',response.data.Status);
            if(response.data.Status){
                NotificationManager.success( response.data.Message,'Success : ',3000)
            }else{
                console.log(response.data.Message);
                NotificationManager.error('Error : ', response.data.Error, 3000)

            }
            
            this.setState({
                name:'',
                arname:'',
                fortenant:false,
                foroutsider:false,
                selectedOption:'',
            },
            ()=>{
                this.fetchService()
            }
            )

        })
        .catch(error=>{
            console.log(error);
            NotificationManager.error('Error : ', error, 3000)

        })
         
      }
    
    changeSort=(e)=>{
        this.setState(
            {
                sort_name:!this.state.sort_name
                // [e.target.name]:!e.target.value
            },()=>{
                this.fetchService() 
            }
        )
    }

    changeTenant=()=>{
        this.setState(
            {
                tenant:!this.state.tenant,
                outsider:false,
                filter:!this.state.tenant,

            },()=>{
                this.fetchService() 
            }
        )
    }
    changeOutsider=()=>{
        this.setState(
            {
                outsider:!this.state.outsider,
                tenant:false,
                filter:!this.state.outsider,
            },()=>{
                this.fetchService() 
            }
        )
    }

    onChange=(e)=>{
        this.setState ({
            [e.target.name]:e.target.value,
            filter:true,
        })
    }
    clearFilters=()=>{
        this.setState({
            filter:false,
            tenant:false,
            outsider:false,
            search_text:"",
            sort_name:true,
        },
        ()=>{this.fetchService()}
        )
    }

    handleKeyPress=(e)=> {
        if(e.charCode==13){
            this.fetchService();    
        } 
    }
    
    render() {

        // console.log("all  data ",this.state.allData);

        let blacklist = []

        var allData =  this.state.allData.map(function(category) {
            if(category.parent){
                blacklist.push(parseInt(category.parent) )
            }
        });
        
        allData = this.state.allData.filter(function(category){
            if(!blacklist.includes(category.id)){
                return category
            }
        })

        // console.log("with parent data ",allData);
        
        
        return (
            <div>

                <NavigationItems />
                {/* Main content */}
                <div className="main-content">
                    <PageHeader pageName="Service" />
                    <div className="header bg-gradient-primary pb-8 pt-5 pt-md-8">
                        <div className="container-fluid">
                            <div className="header-body">
                                {/* Card stats */}
                                <div className="row">
                                    <div className="col-xl-3 col-lg-6">
                                        <div className="input-group input-group-alternative mb-3">
                                            
                                            <input name="search_text" onKeyPress={this.handleKeyPress} value={this.state.search_text} onChange={this.onChange} className="form-control " placeholder="Search Service or Category" type="text" />
                                            <button type="button" className="btn btn-sm btn-white " onClick={this.fetchService}><i className="fa fa-search" aria-hidden="true"></i></button>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                    <div className="col-xl-3 col-lg-6">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Page content */}
                    <div className="container-fluid mt--7">
                        <div className="row">
                            <div className="col-xl-8 mb-5 mb-xl-0">
                                <div className="card shadow">
                                    <div className="card-header border-0">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                
                                                <h3 className="mb-0">
                                                {this.state.filter&&<button className="btn btn-sm bg-translucent-secondary" onClick={this.clearFilters}>clear filters </button>}  Service
                                                    </h3>
                                            </div>
                                            {!this.state.loading&&
                                            <div style={{ height: '100%', flex: 1, justifyContent: 'center', display: 'flex', flexDirection: 'row' }}>
                                                <style dangerouslySetInnerHTML={{ __html: "\n                        .test1:hover{\n                          background-color: rgb(241, 241, 241);\n                          /* box-shadow: 0px 1px 2px 0px grey; */\n                        }\n                      " }} />
                                                <div className="test1" style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10,cursor:"pointer", display: 'flex', height: '100%', flex: 1, justifyContent: 'center', borderBottomLeftRadius: 10, borderTopLeftRadius: 10,backgroundColor:this.state.tenant?'#6072E4':'white',color:this.state.tenant?'white':'black' }} name="tenant" onClick={this.changeTenant}>Tenant</div>
                                                <div className="test1" style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10,cursor:"pointer", display: 'flex', height: '100%', flex: 1, justifyContent: 'center', backgroundColor:!this.state.sort_name?'#6072E4':'white',color:!this.state.sort_name?'white':'black' }} name="sort_name" onClick={this.changeSort}>{this.state.sort_name===true?"A-Z":"Z-A"}</div>
                                                <div className="test1" style={{ boxShadow: '0px 1px 2px 0px grey', padding: 10,cursor:"pointer", display: 'flex', flex: 1, justifyContent: 'center', borderBottomRightRadius: 10, borderTopRightRadius: 10,backgroundColor:this.state.outsider?'#6072E4':'white',color:this.state.outsider?'white':'black' }} name="outsider" onClick={this.changeOutsider}>Outsider</div>
                                            </div>
                                            }

                                            <div className="col text-right">
                                            {this.state.prev==null?<button disabled={true} className="btn btn-sm btn-primary">Prev</button>:<button className="btn btn-sm btn-primary" onClick={this.prev}>Prev</button>}
                                            {this.state.next==null?<button disabled={true} className="btn btn-sm btn-primary">Next</button>:<button className="btn btn-sm btn-primary" onClick={this.next}>Next</button>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        {/* Projects table */}
                                        {this.state.loading?<WaveLoading/>:
                                        <table className="table align-items-center table-flush">
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Service name</th>
                                                <th scope="col">Category name</th>
                                                <th scope="col">tenents</th>
                                                <th scope="col">outsiders</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        
                                        

                                        <tbody>
                                        {
                                            this.state.data.map((item,index) => {
                                                return item.is_reopen?'':<Items 
                                                key={index} 
                                                quotation={item} 
                                                Edit={this.edit}
                                                Delete={this.deleteDay}
                                                />
                                            })
                                        }
                                        </tbody>
                                    </table>
                                        }
                                        
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="card shadow">
                                    <div className="card-header bg-transparent">
                                        <div className="row align-items-center">
                                            <div className="col">
                                                {this.state.edit?
                                                <h2><i className="fas text-red fa-window-close pr-4" onClick={this.clearEdit}></i>Edit Service</h2>
                                                :
                                                <p className="text-bold text-xl bg-transparent"><b >Add Service</b></p>
                                                }
                                                
                                            </div>
                                        </div>
                                        <form role="form">
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control" placeholder="Service name" type="text" value={this.state.name} onChange={(event) => this.setState({name: event.target.value})} />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <select className="form-control-sm form-control" style={{borderColor:'#fafafa',boxShadow:'0px 2px 1px #ededed',paddingLeft:18}}  id="fruit" value={this.state.selectedOption} onChange={this.handleChange}>
                                                    <option value='' disabled>Select category</option>
                                                { allData.map((option,index) => <option key={index} value={option.id} >{option.name}</option>)}
                                                </select>
                                            </div>

                                            

                                            <div className="text-center text-muted mb-4">
                                            </div>
                                            <div className="form-group">
                                                <div className="input-group input-group-alternative mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text"></span>
                                                    </div>
                                                    <input className="form-control"  placeholder="Arabic name" type="text" value={this.state.arname} onChange={(event) => this.setState({arname: event.target.value})} />
                                                </div>
                                            </div> 
                                            <p className="text-bold text-bold-m bg-transparent">User Type</p>
                                            {/* <input type="checkbox" onChange={this.handleCheck} defaultChecked={this.state.checked}/> */}
                                            <input type="checkbox" checked={this.state.fortenant} onChange={(event) => this.setState({fortenant: !this.state.fortenant})} /> Tenant<br />
                                            <input type="checkbox" checked={this.state.foroutsider} onChange={(event) => this.setState({foroutsider: !this.state.foroutsider})} /> Outsider<br />
                                            {this.state.edit&&<><br/>Active <br/><input type="checkbox" checked={this.state.is_active} onChange={(event) => this.setState({is_active: !this.state.is_active})} /> Active<br /></>}
                                        </form>
                                        <div className="text-center">
                                        {this.state.edit?
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.EditDay}>Save</button>
                                            :
                                            <button type="button" className="btn btn-primary mt-4" onClick={this.addService}>Add</button>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footer />
                        {/* Footer */}
                    </div>
                </div>
            </div>

        )
    }
}
